import React from 'react'
import ReactDOM from 'react-dom/client'
import { MsalProvider } from '@azure/msal-react'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { CssBaseline } from '@mui/material'
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles'
import { msalInstance } from '@/auth/msalInstance'
import { theme } from '@/theme/theme'
import { routeTree } from './routeTree.gen'
import { MockDataProvider } from '@/providers/MockDataProvider'

const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

void msalInstance.initialize().then(() => {
  void msalInstance.handleRedirectPromise().catch(() => null).then(() => {
    ReactDOM.createRoot(document.getElementById('root')!).render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <MuiThemeProvider theme={theme}>
            <CssBaseline />
            <MockDataProvider>
              <RouterProvider router={router} />
            </MockDataProvider>
          </MuiThemeProvider>
        </MsalProvider>
      </React.StrictMode>,
    )
  })
})